import React from 'react';
import { Portal } from 'react-portal';
import { createUseStyles } from 'react-jss';
import { P } from './Text';
import { Close } from './Icons';
import { Theme } from '_lib/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  portal: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,

    [theme.r.tablet.up]: {
      padding: theme.r.tablet.gutter,
      right: 0,
      left: 'initial',
      maxWidth: 280,
    },
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    padding: [5, 16],
    background: theme.colors.error,
    borderRadius: 0,
    WebkitFontSmoothing: 'antialiased',

    [theme.r.tablet.up]: {
      borderRadius: 4,
    },
  },
  button: {
    display: 'flex',
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'center',
    width: 30,
    height: 30,
    borderRadius: 30,
    border: 0,
    padding: 0,
    margin: 0,
    marginLeft: 'auto',
    background: 'rgba(255,255,255, 0.2)',
    transition: '0.2s',
    cursor: 'pointer',
    outline: 0,

    '&:hover': {
      background: 'rgba(255,255,255, 0.3)',
    },
  },
}));

type Props = {
  children: React.ReactNode;
  onClose: () => void;
  isShown: boolean;
};

const Toast = (props: Props) => {
  const classes = useStyles();
  const { children, onClose, isShown } = props;

  if (!isShown) {
    return null;
  }

  return (
    <Portal>
      <div className={classes.portal}>
        <div className={classes.container}>
          <P color="#fff">{children}</P>
          <button className={classes.button} onClick={onClose}>
            <Close fill="#fff" width={'18px'} height={'18px'} />
          </button>
        </div>
      </div>
    </Portal>
  );
};

export default Toast;
